module.exports = __webpack_public_path__ + "c58b1c903e17f9d4702928c0d98011a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/lyzak-1.jpg
// module id = 1183
// module chunks = 0